import React from "react"

function Container({ className = "", children }) {
  const containerClassName = `container ${className}`

  return <div className={containerClassName}>{children}</div>
}

export default Container
